import { isArray, isPlainObject, isEmpty, isBoolean, isNumber, each } from 'lodash';
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

// 获取url参数
export const getQueryVariable = (variable) => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable){return pair[1];}
  }
  return(false);
}

/**
 * 将给定的对象移除空属性
 * @params { object|array } data - 给定的对象
 * @params { array } exclude - 需要排除的字段列表，这些字段不会被移除
 * @return { object|array } copyData - 剔除空属性的对象
 *  // test case;
 *  // data = {a:2, b:'', c: {}, d: [], e: false, f: {aa: 222, bb: null}, g: undefined, h:null, i: [{cc:2222}, {}]};
 */
export const removeEmptyProperty = (data, exclude=[]) => {
  // 处理null或undefined输入
  if (data === null || data === undefined) {
    return data;
  }
  
  const copyData = isArray(data) ? [] : {};
  
  // 检查data是否为对象或数组，避免对非可迭代类型调用each
  if (!(isArray(data) || isPlainObject(data))) {
    return data;
  }
  
  each(data, (item, key) => {
    // 检查当前字段是否在排除列表中，如果是则直接保留
    if (exclude.includes(key)) {
      copyData[key] = item;
    } else {
      // 是数组或者json
      if (isArray(item) || isPlainObject(item)) {
          const newItem = removeEmptyProperty(item, exclude);
          if (!isEmpty(newItem)) {
              copyData[key] = newItem;
          }
          // 布尔类型
      } else if (isBoolean(item)) {
          copyData[key] = item;
          // 数字类型
      } else if (isNumber(item)) {
          copyData[key] = item;
          // 基本类型
      } else if (item) {
          copyData[key] = item;
      }
    }
  });
  return copyData;
};

/**
 * 拷贝对象属性，如果目标对象没有该属性，则拷贝该属性
 * @param { object } orig - 原始对象
 * @param { object } dest - 目标对象
 * @return { object } dest - 拷贝后的目标对象
 */
export const copyPropIfNotExist = (orig, dest) => {
  // 检查orig和dest是否为对象类型
  if (typeof orig !== 'object' || orig === null || typeof dest !== 'object' || dest === null) {
    return;
  }

  Object.getOwnPropertyNames(orig).forEach(function (key) {
    // 如果目标对象没有该属性，直接拷贝
    if (!dest.hasOwnProperty(key)) {
      // 如果原始值是对象且不是null，创建对应的对象类型
      if (typeof orig[key] === 'object' && orig[key] !== null) {
        dest[key] = Array.isArray(orig[key]) ? [] : {};
        // 递归拷贝深层属性
        copyPropIfNotExist(orig[key], dest[key]);
      } else {
        // 基本类型直接拷贝
        dest[key] = orig[key];
      }
    } else {
      // 如果目标对象有该属性，且两者都是对象类型，递归处理深层属性
      if (typeof orig[key] === 'object' && orig[key] !== null && 
          typeof dest[key] === 'object' && dest[key] !== null &&
          !Array.isArray(orig[key]) && !Array.isArray(dest[key])) {
        copyPropIfNotExist(orig[key], dest[key]);
      }
    }
  });
};